//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.DrawShapes.js";
import "../no/Builder.js";
import "../no/SelectCurve.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"CreateAlternateFillet",1,0],[1,"FirstCurve",0,"SelectCurve",0],[1,"SecondCurve",0,"SelectCurve",0],[0,"TrimInputCurves",1,0]],[[["placementData"],"SetPlacementData",{},1,0]],[]];
SPLM.Features.DrawShapes.FilletBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DrawShapes.FilletBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DrawShapes.FilletBuilder.PlacementData = class{
    constructor(position,viewMatrix){
        this.position=position;this.viewMatrix=viewMatrix;}
    get Position(){if(this.position === undefined) this.position = new SPLM.Point3d(); return this.position}
    set Position(val){this.position = val}
    get Viewmatrix(){if(this.viewMatrix === undefined) this.viewMatrix = new SPLM.Matrix3x3(); return this.viewMatrix}
    set Viewmatrix(val){this.viewMatrix = val}
};

export default SPLM;